import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../Pages/Home.css';
import HomeBan from "../Components/HomeBan";
import SEO from "../Components/SEO";
import StatsCounter from "../Components/Counter";
import RegionalProjects from "../Components/RegionalProjects";
import CuratedGallery from "../Components/CuratedGallery";
import FAQ from "../Components/FAQ";
import ClientReviews from "../Components/ClientReviews";
import OpeningHours from "../Components/OpeningHours";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaHome,
  FaBuilding,
  FaTools,
  FaCouch,
  FaKey,
  FaDraftingCompass,
  FaCheckCircle,
  FaGem,
  FaFileInvoiceDollar,
  FaUserTie,
  FaCalendarCheck,
  FaComments,
  FaClipboardList,
  FaPaintBrush,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaMoneyBillWave,
  FaHardHat
} from "react-icons/fa";

export default function Home() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    projectType: "",
    location: "",
    budgetRange: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [formSuccess, setFormSuccess] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error for this field
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Full Name is required";
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone Number is required";
    } else if (!/^\d{10}$/.test(formData.phone.trim().replace(/[-+ ]/g, ""))) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.projectType) newErrors.projectType = "Please select a project type";
    if (!formData.location.trim()) newErrors.location = "Location is required";
    if (!formData.budgetRange) newErrors.budgetRange = "Please select a budget range";
    if (!formData.message.trim()) newErrors.message = "Message is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setFormSuccess(true);
      setFormData({
        name: "",
        phone: "",
        email: "",
        projectType: "",
        location: "",
        budgetRange: "",
        message: ""
      });
      setTimeout(() => setFormSuccess(false), 5000);
    }
  };

  return (
    <>
      <SEO
        title="Best Construction in Madurai | Top Builders in Madurai"
        description="VARK Builders Private Limited is recognized as the Best Construction in Madurai and Top Builders in Madurai. Specializing in residential construction in Madurai, home repair in Madurai, and budget friendly house construction across Madurai, Usilampatti, Karaikudi, Sivaganga, Thiruppuvanam, and Theni."
        keywords="BEST CONSTRUCTION IN MADURAI, TOP BUILDERS IN MADURAI, RESIDENTIAL CONSTRUCTION IN MADURAI, HOME REPAIR IN MADURAI, BUDGET FRIENDLY HOUSE CONSTRUCTION IN MADURAI, Best Builders in Usilampatti, Top Builders in Karaikudi, Construction in Sivaganga, Builders in Thiruppuvanam, Top Builders in Theni, Turnkey Civil Contractors Madurai"
        canonicalUrl="https://varkbuilders.com/"
        ratingValue="4.9"
        reviewCount="485"
        breadcrumbs={[
          { name: "Home", url: "/" }
        ]}
      />
      
      <HomeBan />
      
      {/* 1. COMPANY STATS SECTION */}
      <StatsCounter />

      {/* 2. REGIONAL PROJECTS SHOWCASE (Madurai, Coimbatore, Thanjavur, Kumbakonam, Trichy) */}
      <RegionalProjects />

      {/* 3. 15 CURATED ARCHITECTURAL GALLERY WITH LIGHTBOX */}
      <CuratedGallery />

      {/* 4. ABOUT VARK BUILDERS SECTION */}
      <section className="about-vark-section">
        <div className="container">
          <div className="about-vark-grid">
            <div className="about-vark-image" data-aos="fade-right">
              <img 
                src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80" 
                alt="Building Dreams With Trust & Quality" 
                loading="lazy"
              />
              <div className="about-vark-badge">
                <h4>15+ Years</h4>
                <p>Of Building Excellence</p>
              </div>
            </div>
            <div className="about-vark-content" data-aos="fade-left">
              <span className="section-subtitle">Who We Are</span>
              <h2>Building Dreams With <span>Trust & Quality</span></h2>
              <p className="about-lead">
                VARK Builders Private Limited specializes in Residential and Commercial Construction projects with a commitment to quality, transparency and timely delivery.
              </p>
              <p className="about-text">
                With a strong base in Madurai and services spanning across Tamil Nadu, we bridge structural engineering precision and modern architectural aesthetics to construct properties that stand the test of time.
              </p>
              
              <ul className="about-features-list">
                <li><FaCheckCircle className="check-icon" /> Experienced Team</li>
                <li><FaCheckCircle className="check-icon" /> Quality Construction</li>
                <li><FaCheckCircle className="check-icon" /> Modern Design</li>
                <li><FaCheckCircle className="check-icon" /> Budget Friendly Solutions</li>
                <li><FaCheckCircle className="check-icon" /> On-Time Delivery</li>
              </ul>
              
              <div className="about-cta-wrap">
                <Link to="/about" className="accent-btn">Learn More About Us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. SERVICES SECTION */}
      <section className="services-showcase-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Our Services</span>
            <h2>What We <span>Do Best</span></h2>
            <p>We deliver comprehensive construction and design solutions tailored to your residential and commercial needs.</p>
          </div>
          
          <div className="services-showcase-grid">
            <div className="service-card-modern" data-aos="fade-up" data-aos-delay="0">
              <div className="service-card-icon"><FaHome /></div>
              <h3>Residential Construction</h3>
              <p>Specialized luxury villa and individual house construction crafted with premium materials and custom architectural layouts.</p>
              <Link to="/residential" className="service-link-btn">Learn More &rarr;</Link>
            </div>
            
            <div className="service-card-modern" data-aos="fade-up" data-aos-delay="100">
              <div className="service-card-icon"><FaBuilding /></div>
              <h3>Commercial Construction</h3>
              <p>Corporate complexes, office structures, retail outlets, and multi-storey apartments engineered for maximum load capacity and security.</p>
              <Link to="/commercial" className="service-link-btn">Learn More &rarr;</Link>
            </div>
            
            <div className="service-card-modern" data-aos="fade-up" data-aos-delay="200">
              <div className="service-card-icon"><FaTools /></div>
              <h3>Renovation & Remodeling</h3>
              <p>Upgrade and restore your existing structures with technical reinforcement and high-end modern layout planning.</p>
              <Link to="/services" className="service-link-btn">Learn More &rarr;</Link>
            </div>
            
            <div className="service-card-modern" data-aos="fade-up" data-aos-delay="300">
              <div className="service-card-icon"><FaCouch /></div>
              <h3>Interior Works</h3>
              <p>Stunning customized interior design, false ceilings, smart modular kitchens, and premium wardrobe works for homes and offices.</p>
              <Link to="/services" className="service-link-btn">Learn More &rarr;</Link>
            </div>
            
            <div className="service-card-modern" data-aos="fade-up" data-aos-delay="400">
              <div className="service-card-icon"><FaKey /></div>
              <h3>Turnkey Construction</h3>
              <p>Hassle-free end-to-end design and construction management from initial blueprints and approval to final key handover.</p>
              <Link to="/services" className="service-link-btn">Learn More &rarr;</Link>
            </div>
            
            <div className="service-card-modern" data-aos="fade-up" data-aos-delay="500">
              <div className="service-card-icon"><FaDraftingCompass /></div>
              <h3>Architecture & Planning</h3>
              <p>2D/3D floor planning, 3D exterior visualization, structural design drawings, and building approval blueprints.</p>
              <Link to="/services" className="service-link-btn">Learn More &rarr;</Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. WHY CHOOSE US SECTION */}
      <section className="why-choose-vark-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Why Choose Us</span>
            <h2>Our Core <span>Commitments</span></h2>
            <p>VARK Builders stands out as Madurai's premier construction partner by prioritizing quality, clarity, and schedules.</p>
          </div>
          
          <div className="why-choose-grid">
            <div className="why-choose-card-modern" data-aos="fade-up" data-aos-delay="0">
              <div className="why-choose-icon"><FaGem /></div>
              <h3>Quality Materials</h3>
              <p>We source only standard, high-grade materials to ensure long-term structural strength, resilience, and finishing excellence.</p>
            </div>
            
            <div className="why-choose-card-modern" data-aos="fade-up" data-aos-delay="100">
              <div className="why-choose-icon"><FaFileInvoiceDollar /></div>
              <h3>Transparent Pricing</h3>
              <p>Detailed quotations, cost breakdowns, and transparent contracts with absolutely no hidden charges, giving you total peace of mind.</p>
            </div>
            
            <div className="why-choose-card-modern" data-aos="fade-up" data-aos-delay="200">
              <div className="why-choose-icon"><FaUserTie /></div>
              <h3>Professional Team</h3>
              <p>Led by veteran engineers, licensed architects, and certified site supervisors coordinating together for flawless execution.</p>
            </div>
            
            <div className="why-choose-card-modern" data-aos="fade-up" data-aos-delay="300">
              <div className="why-choose-icon"><FaCalendarCheck /></div>
              <h3>Timely Completion</h3>
              <p>Structured timelines and milestone-tracking systems ensure your project is completed and handed over strictly on schedule.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 9. CONSTRUCTION PROCESS SECTION */}
      <section className="construction-process-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Work Process</span>
            <h2>How We <span>Build</span></h2>
            <p>From the first handshake to the keys in your hand, we follow a transparent and streamlined process.</p>
          </div>
          
          <div className="process-timeline">
            <div className="timeline-line"></div>
            
            <div className="timeline-step" data-aos="fade-up" data-aos-delay="0">
              <div className="step-number">01</div>
              <div className="step-icon-box"><FaComments /></div>
              <div className="step-content">
                <h3>Consultation</h3>
                <p>Initial meeting to gather requirements, discuss client expectations, analyze site layout, and align budget boundaries.</p>
              </div>
            </div>
            
            <div className="timeline-step" data-aos="fade-up" data-aos-delay="100">
              <div className="step-number">02</div>
              <div className="step-icon-box"><FaClipboardList /></div>
              <div className="step-content">
                <h3>Planning</h3>
                <p>Developing structural blueprints, executing legal clearances, acquiring building licenses, and drafting scheduling milestones.</p>
              </div>
            </div>
            
            <div className="timeline-step" data-aos="fade-up" data-aos-delay="200">
              <div className="step-number">03</div>
              <div className="step-icon-box"><FaPaintBrush /></div>
              <div className="step-content">
                <h3>Design</h3>
                <p>Finalizing 3D elevation drawings, spatial floor plans, selection of material specifications, and interior layout approvals.</p>
              </div>
            </div>
            
            <div className="timeline-step" data-aos="fade-up" data-aos-delay="300">
              <div className="step-number">04</div>
              <div className="step-icon-box"><FaHardHat /></div>
              <div className="step-content">
                <h3>Construction</h3>
                <p>Civil structure development, brickwork, roofing, tiling, wiring, plumbing, and strict multi-stage quality inspections.</p>
              </div>
            </div>
            
            <div className="timeline-step" data-aos="fade-up" data-aos-delay="400">
              <div className="step-number">05</div>
              <div className="step-icon-box"><FaKey /></div>
              <div className="step-content">
                <h3>Handover</h3>
                <p>Final site cleanup, complete quality checklist validation, walkthrough review, and delivery of keys and document folders.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED PROJECT SECTION (Maintained with premium placeholder image) */}
      <section id="featured-project" className="featured-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Featured Project</span>
            <h2>Snegan Sir's <span>House</span></h2>
            <p>(Lyricist / Kavingar)</p>
          </div>
          <div className="featured-card" data-aos="fade-up">
            <div className="featured-image">
              <img 
                src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&w=1200&q=80" 
                alt="Snegan Sir's House" 
                loading="lazy"
              />
              <div className="badge">Challenging Project</div>
            </div>
            <div className="featured-content">
              <h3>A Masterpiece of Modern Engineering</h3>
              <p>
                One of our most prestigious and challenging projects to date.
                The residence of the renowned lyricist Snegan Sir was designed with
                intricate architectural details and high-end structural requirements.
              </p>
              <div className="features-list">
                <div className="feat-item">Precision Engineering</div>
                <div className="feat-item">Modern Aesthetics</div>
                <div className="feat-item">Luxury Interiors</div>
                <div className="feat-item">Sustainable Design</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 8. CLIENT TESTIMONIALS SECTION */}
      <ClientReviews />

      {/* SERVICE AREAS & REGIONAL HUBS */}
      <section id="service-areas" className="areas-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="subtitle">Our Regional Presence</span>
            <h2>Regional <span>Service Locations</span></h2>
            <p>
              Delivering Best Construction in Madurai and across key Tamil Nadu districts with 4.9/5 verified client satisfaction.
            </p>
          </div>

          {/* Featured Regional Hubs with Dedicated Indexable Pages */}
          <div className="regional-hubs-grid" data-aos="fade-up">
            <Link to="/usilampatti" className="regional-hub-card">
              <div className="hub-top">
                <span className="hub-pin">📍</span>
                <span className="hub-badge">Top Builder</span>
              </div>
              <h3>Usilampatti</h3>
              <p>Budget-friendly house construction & turnkey residential homes from ₹1,850/sq.ft.</p>
              <div className="hub-footer">
                <span className="hub-stars">⭐⭐⭐⭐⭐ 4.9</span>
                <span className="hub-action">Explore Page &rarr;</span>
              </div>
            </Link>

            <Link to="/karaikudi" className="regional-hub-card">
              <div className="hub-top">
                <span className="hub-pin">📍</span>
                <span className="hub-badge">Heritage Hub</span>
              </div>
              <h3>Karaikudi</h3>
              <p>Chettinad heritage fusion villas, luxury residences & home repairs in Sivaganga.</p>
              <div className="hub-footer">
                <span className="hub-stars">⭐⭐⭐⭐⭐ 4.9</span>
                <span className="hub-action">Explore Page &rarr;</span>
              </div>
            </Link>

            <Link to="/sivaganga" className="regional-hub-card">
              <div className="hub-top">
                <span className="hub-pin">📍</span>
                <span className="hub-badge">District Hub</span>
              </div>
              <h3>Sivaganga</h3>
              <p>Reinforced residential structures, modern duplexes & turnkey civil contracting.</p>
              <div className="hub-footer">
                <span className="hub-stars">⭐⭐⭐⭐⭐ 4.9</span>
                <span className="hub-action">Explore Page &rarr;</span>
              </div>
            </Link>

            <Link to="/thiruppuvanam" className="regional-hub-card">
              <div className="hub-top">
                <span className="hub-pin">📍</span>
                <span className="hub-badge">Express Reach</span>
              </div>
              <h3>Thiruppuvanam</h3>
              <p>Vaigai riverfront modern villas & Highway commercial and residential projects.</p>
              <div className="hub-footer">
                <span className="hub-stars">⭐⭐⭐⭐⭐ 4.9</span>
                <span className="hub-action">Explore Page &rarr;</span>
              </div>
            </Link>

            <Link to="/theni" className="regional-hub-card">
              <div className="hub-top">
                <span className="hub-pin">📍</span>
                <span className="hub-badge">Scenic Villas</span>
              </div>
              <h3>Theni</h3>
              <p>Scenic hillside villas, modern family residences & weather-resilient civil builds.</p>
              <div className="hub-footer">
                <span className="hub-stars">⭐⭐⭐⭐⭐ 4.9</span>
                <span className="hub-action">Explore Page &rarr;</span>
              </div>
            </Link>

            <a href="#regional-projects" className="regional-hub-card hub-card-hq">
              <div className="hub-top">
                <span className="hub-pin">🏛️</span>
                <span className="hub-badge hq-badge">Corporate HQ</span>
              </div>
              <h3>Madurai</h3>
              <p>Surya Nagar, Oomachikulam, Avaniyapuram, Thuvariman & 10+ active city zones.</p>
              <div className="hub-footer">
                <span className="hub-stars">⭐⭐⭐⭐⭐ 4.9</span>
                <span className="hub-action">View Projects &rarr;</span>
              </div>
            </a>
          </div>

          {/* Extended Districts Grid */}
          <div className="areas-grid" data-aos="fade-up" style={{ marginTop: "35px" }}>
            <div className="area-item">Coimbatore (RS Puram, Saravanampatti)</div>
            <div className="area-item">Thanjavur (Medical College Rd, Vallam)</div>
            <div className="area-item">Kumbakonam (Swamimalai, Dharasuram)</div>
            <div className="area-item">Trichy (Thillai Nagar, KK Nagar)</div>
            <div className="area-item">Chennai (OMR, Tambaram, Porur)</div>
            <div className="area-item">Salem &amp; Erode Corridor</div>
            <div className="area-item">Dindigul &amp; Batlagundu</div>
            <div className="area-item">All Over Tamil Nadu Turnkey Civil</div>
          </div>
        </div>
      </section>

      {/* 10. ENQUIRY FORM SECTION */}
      <section className="enquiry-form-section" id="enquiry">
        <div className="container">
          <div className="enquiry-wrapper">
            <div className="enquiry-info" data-aos="fade-right">
              <span className="subtitle">Request Consultation</span>
              <h2>Let's Discuss Your <span>Dream Project</span></h2>
              <p>
                Fill out the enquiry form with your project requirements, location, and estimated budget. Our senior civil engineering expert will get in touch within 24 hours to schedule a free initial consultation.
              </p>
              <div className="enquiry-contact-details">
                <div className="info-detail-item">
                  <FaPhoneAltIcon />
                  <div>
                    <h4>Call for Consultation</h4>
                    <p>098429 43377</p>
                  </div>
                </div>
                <div className="info-detail-item">
                  <FaEnvelopeIcon />
                  <div>
                    <h4>Email Support</h4>
                    <p>varkbuilders@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="enquiry-form-card" data-aos="fade-left">
              <h3>Enquiry Form</h3>
              {formSuccess ? (
                <div className="form-success-message">
                  <FaCheckCircle />
                  <h4>Request Submitted Successfully!</h4>
                  <p>Thank you for reaching out. Our consultation expert will contact you shortly.</p>
                </div>
              ) : (
                <form onSubmit={handleFormSubmit} className="consultation-form" noValidate>
                  <div className="form-row-two">
                    <div className="form-input-group">
                      <label htmlFor="name"><FaUser /> Full Name</label>
                      <input 
                        type="text" 
                        id="name" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleInputChange} 
                        placeholder="John Doe"
                        className={errors.name ? "error-input" : ""}
                      />
                      {errors.name && <span className="error-text">{errors.name}</span>}
                    </div>
                    
                    <div className="form-input-group">
                      <label htmlFor="phone"><FaPhone /> Phone Number</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        name="phone" 
                        value={formData.phone} 
                        onChange={handleInputChange} 
                        placeholder="9876543210"
                        className={errors.phone ? "error-input" : ""}
                      />
                      {errors.phone && <span className="error-text">{errors.phone}</span>}
                    </div>
                  </div>

                  <div className="form-row-two">
                    <div className="form-input-group">
                      <label htmlFor="email"><FaEnvelope /> Email Address</label>
                      <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        value={formData.email} 
                        onChange={handleInputChange} 
                        placeholder="name@example.com"
                        className={errors.email ? "error-input" : ""}
                      />
                      {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>

                    <div className="form-input-group">
                      <label htmlFor="projectType"><FaBuilding /> Project Type</label>
                      <select 
                        id="projectType" 
                        name="projectType" 
                        value={formData.projectType} 
                        onChange={handleInputChange}
                        className={errors.projectType ? "error-input" : ""}
                      >
                        <option value="">Select Type</option>
                        <option value="Residential">Residential Construction</option>
                        <option value="Commercial">Commercial Construction</option>
                        <option value="Renovation">Renovation & Remodeling</option>
                        <option value="Interior">Interior Works</option>
                        <option value="Turnkey">Turnkey Construction</option>
                        <option value="Architecture">Architecture & Planning</option>
                      </select>
                      {errors.projectType && <span className="error-text">{errors.projectType}</span>}
                    </div>
                  </div>

                  <div className="form-row-two">
                    <div className="form-input-group">
                      <label htmlFor="location"><FaMapMarkerAlt /> Project Location</label>
                      <input 
                        type="text" 
                        id="location" 
                        name="location" 
                        value={formData.location} 
                        onChange={handleInputChange} 
                        placeholder="e.g. Madurai, Bypass Road"
                        className={errors.location ? "error-input" : ""}
                      />
                      {errors.location && <span className="error-text">{errors.location}</span>}
                    </div>

                    <div className="form-input-group">
                      <label htmlFor="budgetRange"><FaMoneyBillWave /> Budget Range</label>
                      <select 
                        id="budgetRange" 
                        name="budgetRange" 
                        value={formData.budgetRange} 
                        onChange={handleInputChange}
                        className={errors.budgetRange ? "error-input" : ""}
                      >
                        <option value="">Select Budget</option>
                        <option value="<15 Lakhs">Below ₹15 Lakhs</option>
                        <option value="15-30 Lakhs">₹15 Lakhs - ₹30 Lakhs</option>
                        <option value="30-60 Lakhs">₹30 Lakhs - ₹60 Lakhs</option>
                        <option value="60 Lakhs - 1.5 Crore">₹60 Lakhs - ₹1.5 Crore</option>
                        <option value=">1.5 Crore">Above ₹1.5 Crore</option>
                      </select>
                      {errors.budgetRange && <span className="error-text">{errors.budgetRange}</span>}
                    </div>
                  </div>

                  <div className="form-input-group full-width">
                    <label htmlFor="message">Project Requirements / Message</label>
                    <textarea 
                      id="message" 
                      name="message" 
                      value={formData.message} 
                      onChange={handleInputChange} 
                      placeholder="Briefly describe your building dreams..." 
                      rows="4"
                      className={errors.message ? "error-input" : ""}
                    ></textarea>
                    {errors.message && <span className="error-text">{errors.message}</span>}
                  </div>

                  <button type="submit" className="submit-consultation-btn">Request Consultation</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <FAQ />

      <OpeningHours />
    </>
  );
}

// Inline icons for info cards inside enquiry section
function FaPhoneAltIcon() {
  return (
    <div className="enquiry-info-icon-box">
      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.1C224.83 337.7 174 287 131.2 204.2l60.1-49.6a23.9 23.9 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"></path>
      </svg>
    </div>
  );
}

function FaEnvelopeIcon() {
  return (
    <div className="enquiry-info-icon-box">
      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path>
      </svg>
    </div>
  );
}